import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import '../style.scss';
import './style.scss';

function LoaderCard({ isMobile }) {
    return (
        <li className="team__item">
            {!isMobile && (
                <div className="team__userpic">
                    <Skeleton fontSize={112} />
                </div>
            )}
            <div className="team__wrap">
                <div className="team__inner">
                    <span className="team__name">
                        <Skeleton
                            fontSize={isMobile ? 13 : 15}
                            // lineHeight={isMobile ? 20 : 19}
                            lineHeight={isMobile ? 40 : 38}
                            width={isMobile ? 150 : 180}
                        />
                    </span>
                </div>
            </div>
        </li>
    );
}

LoaderCard.propTypes = {
    isMobile: PropTypes.bool.isRequired,
}

export default LoaderCard;
export { LoaderCard };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-team/team/loader-card/index.js